import React from 'react';
import PropTypes from 'prop-types';
import './articleCard.css';

const ArticleCard = props => {
  return <div className="article-card">{props.children}</div>;
};

ArticleCard.defaultProps = {};

ArticleCard.propTypes = {
  children: PropTypes.node,
};

export default ArticleCard;



// WEBPACK FOOTER //
// ./src/ui/src/component/article/articleCard.js